import React, { useCallback, useEffect, useState } from "react";
import { PieChart, Pie, Cell, Legend, ResponsiveContainer } from "recharts";
import { API_URL, colorPrimary, colorSecondory } from "../../constants";
import MyPieChart from "../../components/PieChart";
import { ChartStaticsDto, Configuration, ConfigurationParameters, ReportApi, ReportFilterDto } from "../../api/najd";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";
import dayjs from "dayjs";

export default () => {
  const { t } = useTranslation();
  const [data, setData] = useState<ChartStaticsDto[]>([]);
  const auth = useAuth();

  const token = auth.user?.access_token;
  const configParameters: ConfigurationParameters = {
    basePath: API_URL,
    accessToken: token,
    baseOptions: {
      headers: { Authorization: 'Bearer ' + token },
    }
  };
  const configuration = new Configuration(configParameters);
  const reportApi = new ReportApi(configuration);


  useEffect(() => {
    getData();
  }, []); // Run this effect only once when the component mounts
  function getFirstDayOfMonth(year: number, month: number): Date {
    return new Date(year, month, 1);
  }

  function getLastDayOfMonth(year: number, month: number): Date {
    return new Date(year, month + 1, 0);
  }
  const getData = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    const firstDayOfMonth = getFirstDayOfMonth(currentYear, currentMonth);
    const lastDayOfMonth = getLastDayOfMonth(currentYear, currentMonth);
    const reportFilterDto: ReportFilterDto = {
      fromDate: dayjs(firstDayOfMonth).format('YYYY-MM-DD'),
      toDate: dayjs(lastDayOfMonth).format('YYYY-MM-DD')
    };
    reportApi.reportDocumentStatusReport(
      reportFilterDto
    )
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error('Failed to fetch select options:', error);
      });
  };
  const currentDate = new Date();
  const monthName = currentDate.toLocaleString('ar-EG', { month: 'long' });
  
  console.log(monthName); // Output: نوفمبر
  return (
    <MyPieChart
      data={data}
      localize={true}
      title={ "عدد الطلبات المسجلة مسلمة  في شهر " + monthName } />
  );
};